import currency from "currency.js";

export default {

    itemTotalNetProduct(price, quantity) {
        price = currency(price);
        quantity = currency(quantity);
        return price.multiply(quantity).value;
    },

    itemTotalGrossProduct(totalNet, vatCost) {
        vatCost = currency(vatCost)
        totalNet = currency(totalNet)
        return totalNet.add(vatCost).value;
    },

    itemVatCost(totalNet, vat) {
        vat = currency(vat / 100);
        totalNet = currency(totalNet)
        return totalNet.multiply(vat).value;
    }
}

